const STORAGE_KEY = 'tg-theme-settings';

export const PERSISTED_THEME_FIELDS = [
  'currentTheme',
  'sideNavTheme',
  'navCollapsed',
];

const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

const pickPersisted = (settings = {}) =>
  PERSISTED_THEME_FIELDS.reduce((acc, field) => {
    if (settings[field] !== undefined) {
      acc[field] = settings[field];
    }
    return acc;
  }, {});

export const loadThemeSettings = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? pickPersisted(JSON.parse(raw)) : {};
  } catch (e) {
    return {};
  }
};

// Solo se guardan los campos que el usuario cambió: si nunca eligió tema,
// `currentTheme` no queda guardado y se sigue la preferencia del sistema.
export const saveThemeSettings = (changes) => {
  try {
    const settings = { ...loadThemeSettings(), ...pickPersisted(changes) };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    // localStorage no disponible (modo privado, cuota llena, etc.)
  }
};

export const hasStoredThemeChoice = () =>
  loadThemeSettings().currentTheme !== undefined;

const getDarkSchemeQuery = () => {
  try {
    return window.matchMedia ? window.matchMedia(DARK_SCHEME_QUERY) : null;
  } catch (e) {
    return null;
  }
};

export const getSystemTheme = () => {
  const query = getDarkSchemeQuery();
  if (!query) return undefined;
  return query.matches ? 'dark' : 'light';
};

// Llama a `callback('dark' | 'light')` cuando cambia la preferencia del sistema.
// Devuelve la función para dejar de escuchar.
export const subscribeToSystemTheme = (callback) => {
  const query = getDarkSchemeQuery();
  if (!query || !query.addEventListener) return () => {};
  const handler = (e) => callback(e.matches ? 'dark' : 'light');
  query.addEventListener('change', handler);
  return () => query.removeEventListener('change', handler);
};
